import helper from '../helper'

export default {
  sync ({axios, nexus}) {
    // If during the sync nexus already have a token, set it to axios
    if (nexus.hasToken()) {
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + nexus.getToken()
    }

    // Register interceptors in order to renew expired tokens when receiving errors
    axios.interceptors.response.use(undefined, err => {
      return new Promise((resolve, reject) => {
        // If we got a 401 error
        if (err.response.status === 401 && err.response.config) {
          // If we have a token to renew and this is not a token regeneration
          if (nexus.hasToken() && err.config.url.slice(-24) !== 'account/token/regenerate') {
            nexus.refreshToken()
              .then(result => {
                err.config.headers.Authorization = 'Bearer ' + nexus.getToken()
                nexus.emit('reconnected')

                resolve(axios.request(err.config))
              })
              .catch(error => {
                nexus.forgetToken()
                nexus.emit('disconnected')

                reject(error)
              })
            // If it is a failed retry or no token to be retried
          } else {
            nexus.forgetToken()
            nexus.emit('disconnected')

            reject('No token to be renewed. Session disconnected.')
          }
        } else {
          // If it is a regular error, just reject it
          reject(err)
        }
      })
    })

    // On each token change into nexus, change the token in axios
    nexus.on('changed-token', ({token}) => {
      if (token) {
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + token
      } else {
        axios.defaults.headers.common['Authorization'] = ''
      }
    })
  }
}



//////////////////
// WEBPACK FOOTER
// ./libs/@db2b/nexus-js-v1/vendor/axios.js
// module id = 222
// module chunks = 1